import { ComponentChildren } from 'preact'

export const Show = ({ when, children }: { when: boolean; children: ComponentChildren }) => {
  if (!when) return null
  return <>{children}</>
}
